import type { TIconList } from '@/types/shared-props'

export enum EUI_WITH_ICONS_LAYOUTS {
  GRAPH = 'layout-1',
  BOXES = 'layout-2',
  CONNECTED_GRAPH ='layout-3',
  NOT_FULL_CONNECTED_GRAPH = 'layout-4',
  ROW = 'layout-5',
  COLUMN = 'layout-6'
}
export interface IProps {
  layout?: EUI_WITH_ICONS_LAYOUTS;
  list: TIconList[];
}
